import {Environments} from "../types/environment.type";

const getEnvironment = (): Environments => {
  return process.env.ENVIRONMENT as Environments;
};

export default getEnvironment;
